import React from 'react';
import PropTypes from 'prop-types';
import { getFormInputClassNames } from '../sharedFormFunctions';

import './_textArea.scss';
import '../../../styles/_utilities.scss';

const TextArea = props => (
    <label htmlFor={props.id} className={getFormInputClassNames('c_text-area', props)}>
        <span
            className={`c_text-area__label-text ${props.hideLabelText && 'u_visuallyhidden'}`}
        >{props.labelText}
        </span>
        {props.invalid &&
        <span className="c_text-area__invalid-text">{props.invalidText}</span>
        }
        <textarea
            id={props.id}
            value={props.value}
            onChange={e => props.onChange(e)}
            onBlur={props.onBlur ? e => props.onBlur(e) : null}
            onFocus={props.onFocus ? e => props.onFocus(e) : null}
            placeholder={props.placeholder || null}
        />
    </label>
);

TextArea.propTypes = {
    id: PropTypes.string.isRequired,
    labelText: PropTypes.string.isRequired,
    hideLabelText: PropTypes.bool,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    className: PropTypes.string,  // eslint-disable-line
    placeholder: PropTypes.string,
    invalid: PropTypes.bool,
    invalidText: PropTypes.string
};

TextArea.defaultProps = {
    hideLabelText: false,
    invalid: false,
    invalidText: 'Invalid'
};

export default TextArea;
